module.exports = __webpack_public_path__ + "assets/7d05e9800c0073dc6e016be261633217.mp3";